export default {
  en: {
    search: "Search...",
    select_user_lable: "select user to talk to",
    conversations_title: "Conversations",
    message_input_label: "message",
    message_input_placeholder: "Type your message..",
    introduction_description:
      "chat with agents and supervisors in the call center",
    introduction_title: "Call Center Chatting",
    introduction_action: "click to start new conversation",
    init_chat: "initializing chat...",
    time: {
      today: "Today",
      yesterday: "Yesterday",
    },
    omni: {
      no_active_conversations: "No Active Conversations",
      active_title: "Active Conversations",
      view_btn: "view",
      assign_btn: "Assign",
      close_btn: "Close",
      resending_alert: "resending message...",
      failed_alert: "failed to sent",
      closing_message: "Closing Conversation with {customer}",
      select_conversation_to_view: "Select Conversation to View",
      assigning_agent: "Assigning agent to {customer}",
    },
    assistant: {
      title: "Virtual Assistant",
      empty_title: "Knowledge Center",
      empty_text:
        "Ask & Inquire for call center information with our AI chat assistant",
    },
  },
  ar: {
    search: "بحث...",
    select_user_lable: "إختر مستخدم لبدأ محادثة",
    conversations_title: "المحادثات",
    message_input_label: "الرسالة",
    message_input_placeholder: "اكتب رسالتك...",
    introduction_description:
      "تواصل مع الموظفين والمسؤولين في مركز الإتصال",
    introduction_title: "دردشة مركز الإتصال",
    introduction_action: "اضغط لبدء مخادثة جديدة",
    init_chat: "تهيئة الدردشة....",
    time: {
      today: "اليوم",
      yesterday: "الأمس",
    },
    omni: {
      no_active_conversations: "لا يوجد محادثات جارية",
      active_title: "المحادثات الحالية",
      view_btn: "عرض",
      assign_btn: "إسناد",
      close_btn: "غلق",
      resending_alert: "إعادة ارسال....",
      failed_alert: "فشل الإرسال",
      closing_message: "جاري إغلاق المحادثة الجارية مع العميل {customer}",
      select_conversation_to_view: "اختر المحادثة التي تريد عرضها",
      assigning_agent: "جاري إسناد {customer} إلى عميل آخر",
    },
    assistant: {
      title: "المساعد الإفتراضي",
      empty_title: "بنك المعلومات",
      empty_text:
        "إسأل و استفسر عن أي معلومات متعلقة بمركز الاتصال مع برنامج الذكاء الإصطناعي",
    },
  },
};
